(function () {
	'use strict';
	$(document).ready(function () {

		new Swiper('.swiper-career', {
			slidesPerView: 'auto',
			spaceBetween: 24,
			navigation: {
				nextEl: '.swiper-navigation .swiper-button-next',
				prevEl: '.swiper-navigation .swiper-button-prev',
			},
			breakpoints: {
				576: {
					spaceBetween: 32
				}
			}
		});

		$('.homepage .teams .team').each(function () {
			const content = $(this).find('.content');
			const button = $(this).find('button.with-content');
			const buttonWithChildren = $(this).find('button.with-children');
			const sublist = $(this).find('.sublist');
			clickedOutside(content, () => {
				$(content).removeClass('open')
			}, [button]);
			clickedOutside(sublist, () => {
				$(sublist).removeClass('open').slideUp();
				$(buttonWithChildren).parent('.team').removeClass('open')
			}, [buttonWithChildren]);
		});

		$('.homepage .teams .team button.with-content').on('click', function () {
			$(this).siblings('.content').addClass('open');
		});

		$('.homepage .teams .team button.close-button').on('click', function () {
			$(this).parents('.content').removeClass('open');
		});

		$('.homepage .teams .team button.with-children').on('click', function () {
			$(this).parent('.team').toggleClass('open');
			$(this).siblings('.sublist').toggleClass('open').slideToggle();
		});

		const contentCultureSwiper = new Swiper('.swiper.culture-content-swiper', {
			effect: 'fade',
			autoHeight: true,
			fadeEffect: {
				crossFade: true
			},
			navigation: {
				nextEl: document.querySelector('.homepage .culture-swiper.swiper-navigation .swiper-button-next'),
				prevEl: document.querySelector('.homepage .culture-swiper.swiper-navigation .swiper-button-prev'),
			}
		});

		const imageCultureSwiper = new Swiper('.swiper.culture-image-swiper', {
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
		});
		contentCultureSwiper.controller.control = imageCultureSwiper;
		imageCultureSwiper.controller.control = contentCultureSwiper;


		$('.homepage .top .group').on('mouseenter', function () {
			if (!$(this).hasClass('enter') && !$(this).hasClass('leave')) {
				$(this).addClass("enter");
			}
		});

		$('.homepage .top .group').on('mouseleave', function () {
			if (!$(this).hasClass('leave') && $(this).hasClass('enter')) {
				$(this).removeClass("enter");
				$(this).addClass("leave");
				setTimeout(() => {
					$(this).removeClass("leave");
				}, 850)
			}
		});

		Promise.all(Array.from(document.querySelectorAll('.homepage .images-mobile img')).map(img => {
			if (img.complete)
				return Promise.resolve(img.naturalHeight !== 0);
			return new Promise(resolve => {
				img.addEventListener('load', () => resolve(true));
				img.addEventListener('error', () => resolve(false));
			});
		})).then(results => {
			if (results.every(res => res)) {
				$('.homepage .top').addClass('start');
			}
		});

		$(".js-modal-btn").modalVideo( {
			'ratio': '3:5',
		});



		if ($(window).width() > 576 && $('.homepage').length) {

			gsap.to(".homepage .top .images .group-1",
				{
					scrollTrigger: {
						trigger: '.homepage .top',
						start: "5% top",
						scrub: true
					},
					y: 550,
					left: "-25%",
					scale: 3
				});

			gsap.to(".homepage .top .images .group-2",
				{
					scrollTrigger: {
						trigger: '.homepage .top',
						start: "5% top",
						scrub: true
					},
					y: 150,
					x: 200,
					scale: 2
				});

			gsap.to(".homepage .top .images .group-3",
				{
					scrollTrigger: {
						trigger: '.homepage .top',
						start: "5% top",
						scrub: true
					},
					y: 250,
					left: "120%",
					scale: 2
				});

			gsap.to(".homepage .top .images .group-4",
				{
					scrollTrigger: {
						trigger: '.homepage .top',
						start: "5% top",
						scrub: true
					},
					y: 550,
					left: "120%",
					scale: 4
				});

			gsap.to(".homepage .top .images .group-5",
				{
					scrollTrigger: {
						trigger: '.homepage .top',
						start: "5% top",
						scrub: true
					},
					y: 150,
					left: "-50%",
					scale: 1.2
				});

			gsap.to(".homepage .top .images .group-6",
				{
					scrollTrigger: {
						trigger: '.homepage .top',
						start: "5% top",
						scrub: true
					},
					y: 150,
					left: "-25%",
					scale: 1.8
				});

			gsap.to(".homepage .top .images .group-7",
				{
					scrollTrigger: {
						trigger: '.homepage .top',
						start: "5% top",
						scrub: true
					},
					y: 300,
					left: "120%",
					scale: 2
				});

			gsap.fromTo(".homepage .photos .image:first-child", { y: 100 },
				{
					scrollTrigger: {
						trigger: '.photos',
						scrub: true
					},
					y: -150,
				});

			gsap.fromTo(".homepage .photos .image:last-child", { y: -150 },
				{
					scrollTrigger: {
						trigger: '.photos',
						scrub: true
					},
					y: 100,
				});
		}

	});
}(jQuery));
